import './hotspot.scss';

class Hotspot {
    constructor(element) {
        this.$hotspot = element;
        this.$hotspotToggle = this.$hotspot.querySelector('[data-hotspot-toggle]');
        this.$hotspotPopover = this.$hotspot.querySelector('[data-hotspot-popover]');
        this.$hotspotParentId = this.$hotspot.dataset.hotspotParent;
        this.popoverActive = false;
        this.$hotspotParent = null;
        this.$body = document.querySelector('body');

        if (this.$hotspotParentId !== null) {
            this.$hotspotParent = document.querySelector(`[data-hotspot-container="${this.$hotspotParentId}"]`); // eslint-disable-line
        }
    }

    initialize() {
        if (this.$hotspotToggle && this.$hotspotPopover) {
            this.$hotspotPopover.addEventListener('toggle', (event) => {
                if (!window.mediaMatchHandler[768].matches) {
                    if (event.newState === 'open') {
                        this.$body.style = 'overflow: hidden';
                    }

                    if (event.newState === 'closed') {
                        this.$body.style = '';
                    }
                }
            });

            this.$hotspotToggle.onclick = () => {
                this.popoverActive = !this.popoverActive;

                const anchorRect = this.$hotspotToggle.getBoundingClientRect();

                if (!window.mediaMatchHandler[768].matches) {
                    this.$hotspotPopover.style.removeProperty('top');
                    this.$hotspotPopover.style.removeProperty('left');

                    // because we use the popover as a complete overlay over the screen we have to focus in the popover
                    const $firstCloseBtn = this.$hotspotPopover.querySelector('button');

                    setTimeout(() => {
                        if ($firstCloseBtn) {
                            $firstCloseBtn.focus();
                        }
                    }, 150);
                    
                    if (this.popoverActive === true) {
                        document.addEventListener('keydown', this.handleOutTabEvent);
                    }
                } else {
                    setTimeout(() => {
                        const popoverRect = this.$hotspotPopover.getBoundingClientRect();

                        let top = anchorRect.bottom - anchorRect.height + 30 + window.scrollY;
                        let left = anchorRect.left + anchorRect.width + 20 + window.scrollX;

                        if (this.$hotspotParent !== null) {
                            const hotspotParentRect = this.$hotspotParent.getBoundingClientRect();

                            if (top + popoverRect.height > hotspotParentRect.bottom + window.scrollY) {
                                top = hotspotParentRect.bottom - popoverRect.height + window.scrollY;
                            }

                            if ((left + 320) > hotspotParentRect.width + hotspotParentRect.left) {
                                left = hotspotParentRect.left + hotspotParentRect.width - 320 + window.scrollX;
                            }
                        }

                        this.$hotspotPopover.style.top = top + 'px';
                        this.$hotspotPopover.style.left = left + 'px';
                    }, 1);

                    // to prevent strange position issues we had to close the popover on desktop direct on resize and kill the event for performance optimizing
                    if (this.popoverActive === true) {
                        window.addEventListener('resize', this.handleResize);
                    }
                }
            };

            this.handleResize = () => {
                this.deactivatePopoverInstance();

                window.removeEventListener('resize', this.handleResize);
            };

            this.handleOutTabEvent = (event) => {
                if (event.code === 'Tab' || event.code === 'Tabs') {
                    if (!this.$hotspotPopover.contains(event.target) && this.popoverActive === true) {
                        this.deactivatePopoverInstance();

                        document.removeEventListener('keydown', this.handleOutTabEvent);
                    }
                }
            };

            // to prevent strange position issues we had to close the popover on desktop direct on resize
            window.mediaMatchHandler[768].addEventListener('change', (match) => {
                if (match.matches) {
                    this.deactivatePopoverInstance();
                    document.removeEventListener('keydown', this.handleOutTabEvent);
                }
            });
        }
    }

    deactivatePopoverInstance () {
        this.$hotspotPopover.hidePopover();
        this.popoverActive = false;
        this.$body.style = '';
    }
}

export { Hotspot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$hotspots = $context.querySelectorAll('[data-hotspot="root"]');

        if ($$hotspots.length > 0) {
            $$hotspots.forEach(($hotspot) => {
                const hotspot = new Hotspot($hotspot);
                hotspot.initialize();
            });
        }
    }
});